import React from 'react';
import { addCommas } from 'core/utils/helpers/numbers';

export function TransactionSnapshot({
  transaction, bonusTitle, earnTypeShown, formatRebate,
}) {
  const {
    click = {}, commissionTransactionAmount, transactionDate, rebateAmount, description,
  } = transaction;

  const formattedRebateAmount = formatRebate(rebateAmount);

  return (
    <div className="mn_transaction">
      <p className="mn_transactionMerchant">{click.merchantName || bonusTitle}</p>
      <div className="mn_transactionInfo mn_transactionInfoTop">
        <p>{transactionDate}</p>
        <p>${addCommas(commissionTransactionAmount.toFixed(2))}</p>
      </div>
      <div className="mn_transactionInfo mn_transactionInfoBottom">
        <p className="mn_transactionDescription">{description}</p>
        <p className="mn_transactionReward">{addCommas(formattedRebateAmount)} {earnTypeShown}</p>
      </div>
    </div>
  );
}

export default TransactionSnapshot;
